module.exports = __webpack_public_path__ + "static/media/footer-bg.ca99d536.svg";